import type { FC } from 'react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'

import NavigationV2 from '@segment/templates/Navigation2'

import type { LayoutProps } from '@segment/next-shared/layout'
import Layout from '@segment/next-shared/layout'

import LearnFromVeryBest from '../components/LearnFromVeryBest/LearnFromVeryBest'

import type { HeroProps } from './components/Hero/Hero'
import Hero from './components/Hero/Hero'
import LogoCarousel from './components/LogoCarousel/LogoCarousel'
import RecentEpisodes from './components/RecentEpisodes'

import ogImageJpeg from './assets/OgPodcastHub.jpeg'

const defaultCopy = {
  title: `Good Data, Better Marketing Podcast | Twilio Segment`,
  description: `Good Data, Better Marketing is a podcast that highlights the digital and data trends impacting enterprise businesses today. Each episode interviews a digital leader and seeks to understand how they're using data as a competitive asset in their customer engagement strategies.`,
}

export interface GoodDataBetterMarketingProps extends Partial<LayoutProps> {
  hero: HeroProps
}
const GoodDataBetterMarketing: FC<GoodDataBetterMarketingProps> = ({
  pageTitle = defaultCopy.title,
  pageDescription = defaultCopy.description,
  pageOG = ogImageJpeg,
  hero,
  ...rest
}) => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout pageTitle={pageTitle} pageDescription={pageDescription} pageOG={pageOG} {...rest}>
        <AppearanceProvider appearance="dark">
          <NavigationV2 />
        </AppearanceProvider>
        <Hero {...hero} />
        <Main>
          <LogoCarousel />
          <RecentEpisodes />
          <LearnFromVeryBest />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export default GoodDataBetterMarketing
